import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ConfigurationData, ConfigurationService } from '../_shared/services/configuration.service';

/** Loads latest configuration when navigating to a route. Use on login/home so config is fresh when user navigates back. */
export const configurationResolver: ResolveFn<ConfigurationData> = () => {
  return inject(ConfigurationService).load();
};
